var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2A5284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.403 2.84521H13.1034L9.90731 7.11122H12.7755L5.92425 15.155L8.1405 9.47146H5.63737L8.16131 2.84521H11.403Z",
    fill: "white",
    fillOpacity: 0.704
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.403 2.84521H11.5054L8.63269 7.74628H11.2596L5.92425 15.1544L8.1405 9.47146H5.63737L8.16131 2.84521H11.403Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtho);
export default __webpack_public_path__ + "static/media/vtho.a9ba904be763df022a3d86de3d980653.svg";
export { ForwardRef as ReactComponent };